import { cn } from '@ui/lib/utils.js';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as PToggle } from './PToggle.vue';

export const pToggleVariants = cva(
    cn(
        'inline-flex',
        'items-center',
        'justify-center',
        'gap-2',
        'rounded-lg',
        'font-medium',
        'hover:bg-muted',
        'disabled:pointer-events-none',
        'disabled:opacity-50',
        '[&_svg]:pointer-events-none',
        '[&_svg]:shrink-0',
        'focus-visible:border-border-default',
        'focus-visible:ring-ring-default',
        'focus-visible:ring-3',
        'outline-none',
        'transition-[color,_background-color]',
        'whitespace-nowrap',
    ),
    {
        variants: {
            variant: {
                default: cn(
                    'text-toggle-foreground-on-ghost',
                    'bg-toggle-surface-ghost',
                    'hover:bg-toggle-surface-ghost-hover',
                    'hover:text-toggle-foreground-on-ghost-hover',
                    'data-[state=on]:bg-toggle-surface-ghost-active',
                    'data-[state=on]:text-toggle-foreground-on-ghost',
                    'data-[state=on]:hover:bg-toggle-surface-ghost-hover',
                ),
                outline: cn(
                    'border',
                    'border-border-default',

                    'text-toggle-foreground-on-outlined',
                    'bg-toggle-surface-outline',
                    'hover:bg-toggle-surface-outline-hover',
                    'data-[state=on]:bg-toggle-surface-outline-active',
                    'data-[state=on]:text-toggle-foreground-on-outline',
                ),
            },
            size: {
                default: `h-9 px-2 min-w-9 paragraph-sm [&_svg:not([class*='size-'])]:size-5`,
                xs: `h-7 px-1 min-w-7 paragraph-xs [&_svg:not([class*=\'size-\'])]:size-4`,
                sm: `h-8 px-1.5 min-w-8 paragraph-sm [&_svg:not([class*='size-'])]:size-4`,
                lg: `h-10 px-2.5 min-w-10 paragraph-sm [&_svg:not([class*='size-'])]:size-5`,
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    },
);

export type PToggleVariants = VariantProps<typeof pToggleVariants>;
